customElements.define('header-group', class extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = 0;
    this.headerHeight = this.offsetHeight+"px";
    document.body.style.setProperty('--header-height', this.headerHeight);

    this.megaMenuItems = document.querySelectorAll('.mega-menu__inner');
    this.stickyHeader = document.querySelector('sticky-header');
    
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    this.stickyHeader.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.megaMenuItems.forEach((item) => {
      item.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    });
  }

  onMouseLeave() {
    this.megaMenuItems.forEach((item) => {
      item.classList.remove('mega-menu__inner--shown');
    });

    this.querySelector('.section-header').classList.remove('menu-open');
  }

  show(){
    this.classList.remove('scrolled');
  }

  hide(){
    this.classList.add('scrolled');
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    
    if (currentScrollY < this.lastScrollY) {
      // Scrolling up
      this.show();
    } else if (currentScrollY > this.lastScrollY && currentScrollY > 10) {
      // Scrolling down and past the threshold
      this.hide();
    }
    
    this.lastScrollY = currentScrollY;
  }
});


customElements.define('header-drawer-new', class extends HTMLElement {
  constructor() {
    super();

    this.toggler = this.querySelector('.js-toggle-nav-menu');
    this.navMenu = document.querySelector('.navbar-menu');
    this.toggler.addEventListener('click', this.toggleMenu.bind(this));
  }

  toggleMenu() {
    this.classList.toggle('is-open');
    this.navMenu.classList.toggle('is-open');
  }
});



class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.megaMenuItems = document.querySelectorAll('.mega-menu__inner');

    this.addEventListener('mouseover', this.onMouseOver.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseOver() {
    this.megaMenuItems.forEach((item) => {
      item.classList.remove('mega-menu__inner--shown');
    });
    if(!this.dataset.position){
      document.querySelector('.section-header').classList.remove('menu-open');
      return;
    }
    document.querySelector(`.mega-menu__inner[data-position="${this.dataset.position}"]`).classList.add('mega-menu__inner--shown');
    document.querySelector('.section-header').classList.add('menu-open');
  }
}

customElements.define('header-menu', HeaderMenu);

